import axios from 'axios';
import { useEffect } from 'react';
import { API_DOMAIN } from '../../../constants/api';

const VerifyPassword = () => {
    
    const toPageLogin = (url) => {
        window.location = url;
    };
    const urlCurrent = document.URL;
    const paramUrl = urlCurrent?.split("=");
    const arrParamApi = paramUrl[1]?.split("-") || []
    const params = {
        email: arrParamApi[0],
        id: arrParamApi[1]
    };

    useEffect(() => {
        const verify = async () => {
            try {
                await axios.post(`${API_DOMAIN}verifyMail`, params);
                // const url = response?.data?.url;
                toPageLogin(API_DOMAIN);
            } catch (err) {
                console.log('ERROR: ', err);
            }
        };
        verify();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return <>{document.URL}</>;
};

export default VerifyPassword;
